import Image from 'next/image'
import React from 'react'

import FasLogo from '@/assets/images/common/logo_fas.svg'
import '@/components/Layout/Header/Organisms/Header/HeaderLogo/HeaderLogo.scss'
import ULink from '@/components/Link/ULink'

const HeaderLogo = ({ fixDesign }: { fixDesign: boolean }) => {
  const logo = (
    <>
      <h1 className="l-header__logoMain">
        <Image src={FasLogo.src} alt="FAS" width={FasLogo.width} height={FasLogo.height} />
      </h1>
      <h2 className="l-header__logoCatch">
        Fermentation &amp;
        <br />
        Science
      </h2>
    </>
  )

  return (
    <>
      <div className="l-header__logo">
        {fixDesign ? (
          <div className="l-header__logoAnchor">{logo}</div>
        ) : (
          <ULink className="l-header__logoAnchor" href="/" nextLink={false}>
            {logo}
          </ULink>
        )}
      </div>
    </>
  )
}

export default HeaderLogo
